import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Pages',
    items: [
      { title: 'Home', path: paths.dashboard.root, icon: ICONS.kanban },
      { title: 'Revenue', path: paths.dashboard.revenue, icon: ICONS.analytics },
      { title: 'Organizations', path: paths.dashboard.organizations, icon: ICONS.banking },
      { title: 'Admin Logs', path: paths.dashboard.logs, icon: ICONS.file },
      { title: 'Urgent Failures', path: paths.dashboard.urgentFailures, icon: ICONS.disabled },
      {
        title: 'Transactions to Approve',
        path: paths.dashboard.transactionsToApprove,
        icon: ICONS.menuItem,
      },
      {
        title: 'Flagged checkouts',
        path: paths.dashboard.flaggedCheckouts,
        icon: ICONS.invoice,
      },
      {
        title: 'Flagged deposits',
        path: paths.dashboard.flaggedDeposits,
        icon: ICONS.banking,
      },
      {
        title: 'NEAR Intents assets',
        path: paths.dashboard.nearIntentAssets,
        icon: ICONS.parameter,
      },
      {
        title: 'Mints',
        path: paths.dashboard.mints,
        icon: ICONS.label,
      },
    ],
  },
];
